import { create } from "zustand"
import { devtools } from "zustand/middleware"

export type SessionCropState = {
  tempCropStartDate?: Date
  tempCropEndDate?: Date
  activeCropIdfData?: number // 현재 크롭 편집 중인 선수의 idfData
}

export const initialSessionCropState: SessionCropState = {
  tempCropStartDate: undefined,
  tempCropEndDate: undefined,
  activeCropIdfData: undefined,
}

export type SessionCropStateActions = {
  setTempCropStartDate: (date?: Date) => void
  setTempCropEndDate: (date?: Date) => void
  setActiveCropIdfData: (idfData?: number) => void
  resetTempCrop: () => void
}

export type SessionCropStore = SessionCropState & SessionCropStateActions

export const createSessionCropStore = create<SessionCropStore>()(
  devtools(
    (set) => ({
      ...initialSessionCropState,
      setTempCropStartDate: (date?: Date) => {
        set({ tempCropStartDate: date }, undefined, "setTempCropStartDate")
      },
      setTempCropEndDate: (date?: Date) => {
        set({ tempCropEndDate: date }, undefined, "setTempCropEndDate")
      },
      setActiveCropIdfData: (idfData?: number) => {
        set({ activeCropIdfData: idfData }, undefined, "setActiveCropIdfData")
      },
      resetTempCrop: () => {
        set(
          {
            tempCropStartDate: undefined,
            tempCropEndDate: undefined,
            activeCropIdfData: undefined,
          },
          undefined,
          "resetTempCrop",
        )
      },
    }),
    {
      store: "sessionCropStore",
      enabled: process.env.NODE_ENV !== "production",
    },
  ),
)
